<template>
    <div>
        <b-img src="/images/hayek_logo.png" center></b-img>
        <b-row>
            <b-col md="2"></b-col>
            <b-col md="8">
                <b-card class="mt-3">
                    <h3 class="mb-3">Reset Your Password</h3>
                    <p>
                        If you've forgotten your password, don't worry! By entering your email address below,
                        you'll receive a unique reset code sent to your inbox. This code will allow you to
                        securely reset your password and regain access to your account. Your password will
                        not be changed until you successfully verify the code and complete the reset process.
                    </p>
                    <p>
                        If you don’t see the email in your inbox within a few minutes, please check your spam or
                        junk folder as it might have been filtered there.
                    </p>
                    <hr>
                    <p>Enter your email address below to receive a password reset code.</p>

                    <div class="alert alert-success" v-if="successMessage">
                        {{ successMessage }}
                    </div>
                    <div class="alert alert-danger" v-if="errorMessage">
                        {{ errorMessage }}
                    </div>
                    <b-form @submit="onSubmit" @submit.stop.prevent>
                        <b-form-group id="input-group-1">
                            <b-form-input id="email" v-model="email" type="email" placeholder="Enter email"
                                :class="{ 'is-invalid': validation.hasError('email') }" required></b-form-input>
                            <div class="invalid-feedback" v-if="validation.hasError('email')">
                                {{ validation.firstError('email') }}
                            </div>
                        </b-form-group>
                        <hr>
                        <b-row>
                            <b-col>
                                <b-button type="submit" variant="primary" :disabled="isLoading">
                                    {{ isLoading ? 'Sending...' : 'Send Reset Code' }}
                                </b-button>
                            </b-col>
                            <b-col>
                                <a href="/reset-code" class="btn btn-link float-right">I already have a reset code</a>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
            <b-col md="2"></b-col>
        </b-row>
    </div>
</template>

<script>
import { HTTP } from "../../http-common";
import SimpleVueValidation from "simple-vue-validator";

const Validator = SimpleVueValidation.Validator;

export default {
    data() {
        return {
            email: "",
            isLoading: false,
            successMessage: "",
            errorMessage: "",
        };
    },
    mixins: [SimpleVueValidation.mixin], // Attach SimpleVueValidation
    validators: {
        email: function (value) {
            return Validator.value(value)
                .required("Email is required.")
                .email("Invalid email address.");
        },
    },
    methods: {
        async onSubmit(event) {
            event.preventDefault();

            // Validate email field
            this.$validate().then(async (success) => {
                if (!success) {
                    return; // Stop form submission if validation fails
                }

                this.isLoading = true;
                this.successMessage = "";
                this.errorMessage = "";

                try {
                    await HTTP.post("/auth/reset-password", { email: this.email }); // Removed `const response =`
                    this.successMessage = "A reset code has been sent to your email.";
                } catch (error) {
                    if (error.response && error.response.status === 404) {
                        this.errorMessage = "Email not found. Please check and try again.";
                    } else {
                        this.errorMessage = "An error occurred. Please try again later.";
                    }
                } finally {
                    this.isLoading = false;
                }
            });
        }
    },
};
</script>

<style scoped>
.invalid-feedback {
    display: block;
}
</style>